export default {
  minLength: 'Minimum length',
  maxLength: 'Maximum length',
  addAttribute: 'Add attribute',
  customAttribute: 'Custom attribute',
  showQuestionNumber: 'Show question number',
  textareaRowCount: 'Row count',
  minValue: 'Minumum value',
  maxValue: 'Maximum value',
  decimalNumber: 'Decimal number',
  areYouSureYouWantToDeleteThisAttribute:
    'Are you sure you want to delete this attribute?',
  addCustomAttribute: 'Add custom attribute',
  attrTypes: {
    string: 'Text',
    number: 'Number',
    boolean: 'Yes/No',
    object: 'Key:Value'
  },
  duplicatedItem: 'Duplicated item',
  thumbAttrs: 'Image',
  id: 'Id',
  class: 'Class',
  style: 'Style',
  width: 'Width',
  height: 'Height',
  accept: 'Accepted file extentions',
  optionAttrs: 'Option',
  colAttrs: 'Column',
  textAttrs: 'Text',
  show: 'Show',
  descriptionAttrs: 'Description',
  optionNumberAttrs: 'Option number',
  numberingType: 'Numbering type',
  numberingTypeOptions: {
    number: 'Number (1, 2, 3, ...)',
    persianAlphabet: 'Persian alphabet (الف، ب، پ، ...)',
    englishAlphabet: 'English alphabet (A, B, C, ...)'
  },
  inputName: 'Input title',
  imageOptionAttrs: 'Option',
  src: 'Image address',
  format: 'Format',
  noImageUrl: 'Default image address',
  git: 'Gif',
  showNoImage: 'Default image',
  fitIn: 'Image scale correction',
  fluidGrow: 'Responsive and scalable',
  fluid: 'Responsive',
  thumbor: 'Volume optimization',
  effects: 'Image effects',
  brightness: 'Brightness',
  blur: 'The degree of blur',
  contrast: 'Contrast',
  quality: 'Quality',
  dropdownAttrs: 'Dropdwon',
  uploaderAttrs: 'Uploader',
  multiple: 'Multiple uploader',
  squareImage: 'Square image',
  uploadMaxSize: 'Maximum file size (byte)',
  autoScale: 'Auto scale image (pixel)',
  rangeAttrs: 'Range',
  min: 'Minimum',
  max: 'Maximum',
  interval: 'Interval',
  duration: 'Animation duration',
  marks: 'Show values',
  scoreAttrs: 'Score',
  inactiveColor: 'Inactive color',
  activeColor: 'Active color',
  borderColor: 'Border color',
  activeBorderColor: 'Active border color',
  glowColor: 'Glow color',
  textClass: 'Text class',
  increment: 'Increment amount',
  rating: 'Rating',
  maxRating: 'Maximim rating',
  fixedPoints: 'Fixed points',
  starSize: 'Star size',
  borderWidth: 'Border width',
  glow: 'Glow',
  readOnly: 'Read only',
  showRating: 'Show rating',
  rtl: 'Right to left',
  roundStartRating: 'Round rating',
  clearable: 'Clearable',
  roundedCorners: 'Rounded corners',
  template: 'Template',
  slef: 'Same page',
  blank: 'New page',
  wrapperAttrs: 'Widget tag',
  widgetAttrs: 'Widget',
  headerAttrs: 'Widget header',
  rowAttrs: 'Row tag',
  swiperAttrs: 'Slider',
  linkAttrs: 'Link',
  iconAttrs: 'Icon',
  contentAttrs: 'Content tag',
  ulAttrs: 'List',
  liAttrs: 'List item',
  titleAttrs: 'Title',
  subTitleAttrs: 'Subtitle',
  dividerAttrs: 'Divider line',
  titleDividerAttrs: 'Title divider line',
  moreLinkAttrs: 'More link',
  showHeader: 'Show header',
  showDivider: 'Show divider line',
  showTitleDivider: 'Show title divider line',
  showMoreLink: 'Show more linl',
  to: 'Link',
  target: 'Open method',
  text: 'Text',
  icon: 'Icon',
  prefetch: 'Auto download files',
  noGutters: 'Remove spaces',
  serverLimitedCount: 'Server visible count',
  firstSlideClass: 'First slide class',
  lastSlideClass: 'Last slide class',
  controlsClass: 'Next/Prev buttons class',
  pagination: 'Pagination',
  slideClass: 'Slide class',
  accordionAttrs: 'Accordion',
  accordionIconAttrs: 'Accordion icon',
  defaultIcon: 'Default icon',
  expandIcon: 'Expanded state icon',
  expandFirst: 'Expand first item',
  breakpoints: 'Breakpoints',
  slidesPerView: 'Slide per view',
  spaceBetween: 'Space between slides',
  wrapperAreaAttrs: 'Area tag',
  areaAttrs: 'Area',
  wrapperPageAttrs: 'Page tag',
  pageAttrs: 'Page',
  inputAttrs: 'Input',
  validation: 'Validation rules',
  inputType: 'Input type',
  required: 'Required',
  showImagePreview: 'Show image preview gallery on click',
  imagePreviewImages: 'Gallery image addresses'
}
